<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L6.58579 16.0001H3C2.44772 16.0001 2 15.5523 2 15.0001V9.00005C2 8.44777 2.44772 8.00005 3 8.00005H6.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005ZM10 7.41427L7.70711 9.70716C7.51957 9.89469 7.26522 10.0001 7 10.0001H4V14.0001H7C7.26522 14.0001 7.51957 14.1054 7.70711 14.2929L10 16.5858V7.41427ZM14.0923 8.58045C14.324 8.07914 14.9183 7.8606 15.4196 8.09234C16.979 8.81319 18 10.3141 18 12.0001C18 13.686 16.979 15.1869 15.4196 15.9078C14.9183 16.1395 14.324 15.921 14.0923 15.4197C13.8606 14.9183 14.0791 14.3241 14.5804 14.0923C15.4513 13.6898 16 12.8831 16 12.0001C16 11.117 15.4513 10.3103 14.5804 9.90776C14.0791 9.67602 13.8606 9.08177 14.0923 8.58045Z"
    fill="currentColor"
  />
</svg>
